export enum FillStpRequirement {
  STP_ALL,
  STP_NONE,
  STP_AS_NEEDED,
}

export namespace FillStpRequirement {
  let elements = [
    FillStpRequirement.STP_ALL,
    FillStpRequirement.STP_NONE,
    FillStpRequirement.STP_AS_NEEDED,
  ];
  let alias = "com.bcdfx.model.FillStpRequirement";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
